import Sections from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/Sections';
import {
  useArticlesFilterContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/Filter/ArticlesFilterContext';
import { filtersComponentsMapping, filtersTitleMapping } from './config';

const SidebarSections = (props) => {
  const { state: { isFetching, items } } = useArticlesFilterContext();

  return (
    <Sections
      { ...props }
      isFetching={ isFetching }
      items={ { ...(items.filter || {}) } }
      filtersTitleMapping={ filtersTitleMapping }
      filtersComponentsMapping={ filtersComponentsMapping }
    />
  );
};

export default SidebarSections;
